/**
 * GA-2: only a genuine credentials rejection may read as a wrong password.
 * Auth.js reports infra failures (backend 5xx / network) as "Configuration" —
 * blaming the member's password for those sent people into password resets
 * during our outages. Sub-codes ride CredentialsSignin (auth.ts):
 * rate_limited (429) and link_refused (409) each get their honest sentence.
 */
export function passwordSignInErrorMessage(
  error: string,
  code?: string | null,
): string {
  if (error !== "CredentialsSignin") {
    return "Sign-in is having a problem on our side — your password may be fine. Try again in a moment.";
  }
  if (code === "rate_limited") {
    return "Too many sign-in attempts. Wait a minute, then try again.";
  }
  if (code === "link_refused") {
    return "This sign-in is linked to a different account, so it was refused. Contact support if this is unexpected.";
  }
  return "That email and password combination didn't work.";
}
